import React, { Component } from 'react';
import {connect} from 'react-redux';
import {PendingTransaction} from '../../../components/PendingTransaction';
import {EmptyList} from '../../../components/EmptyList';

class Queue extends Component {
    render() {
        let {pendingTransactions} = this.props;

        return (
            <>
            <div className="modal fade" id="popupQueue" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Xác nhận giao dịch</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body text-center no-pad-gutters">
                        {
                            pendingTransactions.length > 0 ?
                            <div className="responsive-full-wrap limited">
                                <table className="table w-100 queue">
                                <thead>
                                    <tr>
                                        <th width="180">THỜI ĐIỂM</th>
                                        <th>MÃ GD MERCHANT</th>
                                        <th>SỐ TIỀN</th>
                                        <th width="150" className="text-center">XÁC NHẬN</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        pendingTransactions.map((value) => 
                                            <PendingTransaction value={value} approve={this.props.approve} cancel={this.props.cancel} />
                                        )
                                    }
                                </tbody>
                                </table>
                            </div> :
                            <EmptyList type={1}/>
                        }
                    </div>
                    <div className="modal-footer">
                        <div className="row w-100 justify-content-center">
                            <div className="col-8 col-sm-5">
                                <button type="button" className="btn btn-main w-100" data-dismiss="modal">ĐÓNG</button>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
	return {
		pendingTransactions: state.queueData.transactions
	}
};

export default connect(mapStateToProps)(Queue);
